import type { OrderApiResponse } from 'src/libs/api/response/OrderApiResponse';
import { isBrowser, isProduction, isStaging } from 'src/libs/wa/utils/env';
import { isAffiliatesOne } from 'src/utils/affiliatesOne';
import { getCookieNames } from 'src/utils/cookies';

export const MargeScriptMeasurement = () => {
  if (!isBrowser()) return;
  const urlParams = new URLSearchParams(window.location.search);
  // Avoid double tracking if accessing from affiliates one after accessing from marge
  if (isAffiliatesOne(urlParams.get('utm_medium'), urlParams.get('utm_source'), urlParams.get('vtm_stat_id'))) {
    clearMargeLocalStorage();
    deleteMargeAffiliateCookies();
    return;
  }

  const doc = document as any;
  const jsTag = doc.createElement('script');
  jsTag.innerHTML = `
  (function(){
    var uqid = "c5e3c193y273353e";
    var gid  = "4";
    var a=document.createElement("script");
    a.dataset.uqid=uqid;a.dataset.gid=gid;a.id="afadfpc-c5e3c193y273353egid4-"+Date.now();
    a.src="//af-wamazing.catsys.jp/fpc/cookie_js.php?scriptId="+encodeURIComponent(a.id);
    document.head.appendChild(a);
  })();
  `;
  jsTag.charset = 'UTF-8';
  doc.body.appendChild(jsTag);
};

const clearMargeLocalStorage = () => {
  const localStorageKeys = Object.keys(localStorage);
  localStorageKeys.forEach((key) => {
    if (key.includes('c5e3c193y273353e')) localStorage.removeItem(key);
  });
};

const deleteMargeAffiliateCookies = () => {
  const cookieNames = getCookieNames();
  cookieNames.forEach((name) => {
    if (isCookieToDelete(name)) {
      const domain = getCookieDomain();
      deleteCookie(name, domain);
    }
  });
};

const deleteCookie = (name: string, domain: string) => {
  document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; domain=${domain}; path=/`;
};

const isCookieToDelete = (name: string): boolean => {
  return ['RCTG', 'RCTC', 'P_GCATS', 'P_CCATS', 'GCATS', 'CTG', 'CTC', 'CCATS'].some((cookieName) =>
    name.includes(cookieName)
  );
};

const getCookieDomain = () => {
  if (isProduction()) return '.wamazing.com';
  if (isStaging()) return '.staging-wamazing.com';
  return '.lvh.me';
};

export const margeTrackItemPurchasedFromAd = (order: OrderApiResponse) => {
  const hasVisitedWithAffiliatesOneBefore = () => {
    const utmMedium = localStorage.getItem('utm_medium');
    const utmSource = localStorage.getItem('utm_source');
    const vtmStatId = localStorage.getItem('vtm_stat_id');
    return utmMedium === 'cpa' && utmSource === 'affiliates' && vtmStatId !== null;
  };
  if (hasVisitedWithAffiliatesOneBefore()) return;
  const executedOrderIds = JSON.parse(localStorage.getItem('executedOrderIds') || '[]');
  if (executedOrderIds.includes(order.orderId)) return;
  const doc = document as any;
  const jsTag = doc.createElement('script');
  jsTag.innerHTML = `
  (function(){
    var uqid   = "c5e3c193y273353e";
    var gid    = "4";
    var uid   = "${order.orderId}";
    var uid2   = "";
    var af   = "";
    var pid    = "";
    var amount = "${order.paymentAmount}";
    var a=document.createElement("script");
    a.src="//af-wamazing.catsys.jp/ac/action_js.php";
    a.id="afadaction-"+Date.now();
    a.addEventListener("load",function(){(new fpcAction(a.id)).groupAction(gid, af, [uid, uid2], pid, amount, uqid)});
    document.head.appendChild(a)})();
  `;
  jsTag.charset = 'UTF-8';
  doc.body.appendChild(jsTag);
  executedOrderIds.push(order.orderId);
  localStorage.setItem('executedOrderIds', JSON.stringify(executedOrderIds));
};
